import { ROUTE_NAMES } from '../../../constants';

export const isDNIStep = (stepName: string) => {
  const dniSteps = [
    null,
    ROUTE_NAMES.RegistrationType,
    ROUTE_NAMES.AutoPhotoFrontDNI,
    ROUTE_NAMES.AutoPhotoBackDNI,
    ROUTE_NAMES.EditFrontDNI,
  ];
  return dniSteps.includes(stepName);
};

export const shouldRemoveSessionPhone = (stepName: string, isPA: boolean) => {
  if (isPA) {
    return true;
  }
  return !isDNIStep(stepName);
};
